/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * The updated attendance status
 */
export enum MarkAttendanceResponseAttendanceStatus {
  ATTENDED = 'ATTENDED',
  NO_SHOW = 'NO_SHOW',
  UNKNOWN = 'UNKNOWN'
}
